export default "__VITE_ASSET__Blf9Yrdl__"